import { supabase, SupabaseConnector } from "../database/SupabaseConnector"
import { SetNodesState, UIColumn, UISheet } from "../types/UITypes"
import { Dispatch, SetStateAction } from "react"

export async function updateColumn(
  sheetId: string,
  updatedColumn: UIColumn,
  setNodes: SetNodesState
) {
  await supabase
    .from("column_info")
    .update({
      text: updatedColumn.text,
      column_index: updatedColumn.columnIndex,
      width: updatedColumn.width,
    })
    .eq("id", updatedColumn.id)

  setNodes((nodes) =>
    nodes.map((node) =>
      node.data.id !== sheetId
        ? node
        : {
            ...node,
            data: {
              ...node.data,
              columns: [
                ...((node.data as UISheet).columns || []).map((sheetColumn) => {
                  return sheetColumn.id === updatedColumn.id
                    ? {
                        ...sheetColumn,
                        text: updatedColumn.text,
                        width: updatedColumn.width,
                      }
                    : sheetColumn
                }),
              ],
            },
          }
    )
  )
}

export async function updateRowLabel(
  sheetId: string,
  rowIndex: number,
  text: string,
  setNodes: SetNodesState,
  canvasId: string
) {
  const response = await supabase
    .from("row_label")
    .select()
    .eq("sheet_id", sheetId)
    .eq("row_index", rowIndex)

  if (!response.data?.length) {
    const { data } = await supabase
      .from("row_label")
      .insert({
        canvas_id: canvasId,
        sheet_id: sheetId,
        row_index: rowIndex,
        text,
      })
      .select()

    setNodes((nodes) =>
      nodes.map((node) => {
        return node.data.id !== sheetId
          ? node
          : {
              ...node,
              data: {
                ...node.data,
                rowLabels: [
                  ...((node.data as UISheet).rowLabels || []),
                  {
                    id: data?.length ? data[0].id : "",
                    text,
                    rowIndex,
                  },
                ],
              },
            }
      })
    )
  } else {
    await supabase
      .from("row_label")
      .update({
        text,
      })
      .eq("sheet_id", sheetId)
      .eq("row_index", rowIndex)

    setNodes((nodes) =>
      nodes.map((node) =>
        node.data.id !== sheetId
          ? node
          : {
              ...node,
              data: {
                ...node.data,
                rowLabels: [
                  ...((node.data as UISheet).rowLabels || []).map((rowLabel) =>
                    rowLabel.rowIndex === rowIndex
                      ? { ...rowLabel, text }
                      : rowLabel
                  ),
                ],
              },
            }
      )
    )
  }
}

export async function confirmMatrixLabel(
  matrixLabel: string,
  editedMatrixProps:
    | {
        id: string
        labelType: string
      }
    | undefined,
  setNodes: SetNodesState,
  setMatrixLabelEditorOpen: Dispatch<SetStateAction<boolean>>,
  setMatrixLabel: Dispatch<SetStateAction<string>>,
  supabaseConnector: SupabaseConnector
) {
  if (!editedMatrixProps) {
    return
  }

  const editedLabelPropName = editedMatrixProps.labelType

  setNodes((nodes) =>
    nodes.map((node) =>
      node.data.id !== editedMatrixProps.id
        ? node
        : {
            ...node,
            data: { ...node.data, [editedLabelPropName]: matrixLabel },
          }
    )
  )

  setMatrixLabelEditorOpen(false)
  setMatrixLabel("")

  supabaseConnector.updateMatrixLabel(
    editedLabelPropName,
    matrixLabel,
    editedMatrixProps.id
  )
}
